import React from 'react'
import Holidays from '../features/HolidayList/Holidays'
import { Grid } from '@mui/material'

function HolidayList() {
  return (
    <Grid sx={{overflow:'auto'}}>
      <Holidays />
    </Grid>
  )
}

export default HolidayList
